import { ComponentProps } from 'react';
import clsx from 'clsx';
import { OpInput } from 'new-components/DLS/OpInput/OpInput';
import { OpSkeleton } from 'new-components/DLS/OpSkeleton/OpSkeleton';
import { useOpFormContext } from '../../OpFormContext';
import { OpForm } from '../../OpForm';

interface OpFormSearchInputProps
  extends Pick<
      ComponentProps<typeof OpForm.Item>,
      | 'name'
      | 'label'
      | 'rules'
      | 'tooltip'
      | 'validateTrigger'
      | 'validateStatus' // Temp: For SUIR wrapped version
      | 'help' // Temp: For SUIR wrapped version
      | 'required' // Temp: For SUIR wrapped version
    >,
    Omit<ComponentProps<typeof OpInput.Search>, 'name' | 'required'> {
  formItemClassName?: string;
  isLoading?: boolean;
}

export const OpFormSearchInput = ({
  formItemClassName,
  name,
  label,
  rules,
  tooltip,
  validateTrigger,
  required, // TEMP: For old form component validation
  validateStatus, // TEMP: For old form component validation
  help, // TEMP: For old form component validation

  // For skeleton loading state
  isLoading,

  // Wrapped element props
  disabled,

  ...elementProps
}: OpFormSearchInputProps) => {
  /** The Form is wrapped in a provider that passes the loading and readOnly
   * contexts to the component */
  const { isDataLoading, isReadOnly } = useOpFormContext();

  return (
    <OpForm.Item
      className={clsx('op-form-search-input', formItemClassName)}
      name={name}
      label={label}
      rules={rules}
      tooltip={tooltip}
      validateTrigger={validateTrigger}
      required={required} // TEMP: For old form component validation
      validateStatus={validateStatus} // TEMP: For old form component validation
      help={help} // TEMP: For old form component validation
    >
      {isDataLoading || isLoading ? (
        /** A placeholder in the shape of the component
         * so we can immediately render the structure of the form while
         * data is loading */
        <OpSkeleton.Input active block />
      ) : (
        /** The actual component that is rendered when we have the data */
        <OpInput.Search disabled={isReadOnly || disabled} {...elementProps} />
      )}
    </OpForm.Item>
  );
};
